import React, { useState } from "react";
import { getSectionHeight, getAdjustingFontSizeByHeightWidth, getScreenSize, getIsMobile, getIsTablet } from "../globalConstants";
import BluePlayWithFriends from "../assets/pokerNightWithFriends.jpg";
import { WhiteOutlineText } from "./whiteOutlineText";
import AppLogoTeal from "../assets/appLogoTeal.png";
import { backgroundDiv } from "./leadSection";

const faqs = [
    {
        question: "What is Parallel Poker?",
        answer: "In Parallel Poker, players play the same deals as each other against the same AI opponent.\nFor every hand, the value of the chips you won or lost is <strong>compared to other players</strong>.\nFor example, losing $100 on a hand where the average player loses $200 would be scored as +$100, whereas winning $100 when the average player is winning $200 is scored as -$100.\nParallel Poker is significantly <strong>less luck-based</strong> and <strong>more skill-based</strong> than other poker games, because every bad beat or lucky break that happens to you also happens to the players you compare against."
    },
    { question: "Is Parallel Poker a gambling app?", answer: "No, there is <strong>no gambling at all</strong> on Parallel Poker, either with real currency or paid-for virtual currency.\nWe display scores in terms of $ but you do not need to purchase this fake money - it just appears when you start a game and you can never run out." },
    { question: "Is this app free to use?", answer: "Yes! You also get access to premium feedback features for your first 36 deals.\nWe offer an optional premium tier subscription which gives access to in-app hand-analysis, all feedback features, and playstyle and win-rate analysis." },
    { question: "Can I play Parallel Poker with my friends?", answer: "Yes, absolutely! We offer head-to-head games we call 'challenges' for you to play with your friends.\nYou and your friend can <strong>compete at different times of the day and you can even compete in challenges whilst offline</strong>. You'll sync your results later once you reconnect to the internet - a perfect way to make your daily commute much more social and fun!" },
    { question: "Can I play Parallel Poker solo?", answer: "Yes, for solo play we recommend checking out our 'Seasons' game mode.\nEvery tournament you play is scored against the expected result for a player of your skill level (determined by your in-app rating).\nAfter every tournament, if you outperform expectations, you're rating will go up, and if you underperform, it will go down." },
    { question: "Is the post-hand GTO feedback simple and fun?", answer: "Yes! We've presented the analysis in a <strong>focused, engaging, and accessible way</strong> for all players, so you can focus on having fun!\nNB: Parallel Poker does not teach the rules of poker, it teaches poker strategy." },
    { question: "What are the quality of life features?", answer: "- Play anytime anywhere\n- Close the app mid-hand, restart later where you left off\n- Play at your own pace with no game clock and no stress\n- Always get dealt playable hands\n- Play offline, or lose connection mid-hand and keep playing without issue" }
];
const FAQAccordion = ({ faqs, openIndex, setOpenIndex = (value) => { } }) => {


    const toggleAccordion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const formatAnswer = (answer: string) => {
        // Split the answer by newlines and map to <p> elements, allowing HTML tags
        const len = answer.replace("strong>", "")
        return answer.split('\n').map((line, index) => (
            <p
                key={index}
                style={{
                    fontFamily: "Regular",
                    margin: getIsMobile() ? "5%" : "3%",
                    fontSize: Math.max((getIsMobile() ? (getScreenSize().height < 450 ? getScreenSize().width * 0.025 : getScreenSize().width * 0.05) : getScreenSize().width * 0.011) * 0.8, (getIsMobile()) ? 14 : (getScreenSize().height < 450 ? 10 : (getScreenSize().width > getScreenSize().height ? 20 : 26)))
                }}
                dangerouslySetInnerHTML={{
                    __html: line.replace(/<strong>(.*?)<\/strong>/g, '<strong style="font-weight: 900; font-family: Bold;">$1</strong>')
                }}
            />
        ));
    };
    const maxWidthPx = getIsMobile() ? "600px" : "1000px"
    const maxWidth = parseInt(maxWidthPx.replace("px", ""))
    // alert(Math.max(getIsMobile() ? (getScreenSize().height < 450 ? getScreenSize().width * 0.001 : getScreenSize().width * 0.05) : getScreenSize().width * 0.011, (getIsMobile()) ? 14 : (getScreenSize().height < 450 ? 10 : (getScreenSize().width > getScreenSize().height ? 28 : 38))),)
    return (
        <div style={{ width: "90%", maxWidth: maxWidthPx, justifyContent: "center", alignItems: "center" }}>
            {faqs.map((faq, index) => (
                <div
                    key={index}
                    style={{
                        marginBottom: "10px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)", // Shadow effect for each tile
                        borderRadius: "8px"
                    }}
                >
                    <div
                        style={{
                            cursor: "pointer",
                            fontWeight: "bold",
                            fontSize: Math.max(getIsMobile() ? (getScreenSize().height < 450 ? getScreenSize().width * 0.035 : getScreenSize().width * 0.05) : getScreenSize().width * 0.011, (getIsMobile()) ? 14 : (getScreenSize().height < 450 ? 13 : (getScreenSize().width > getScreenSize().height ? 24 : 32))),
                            padding: getIsMobile() ? "3%" : "2%",
                            backgroundColor: "#f5f5f5",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderRadius: openIndex === index ? "8px 8px 0 0" : "8px", // Unround bottom corners if open
                            border: "1px solid #ccc", // Optional border for better visibility
                            transition: "background-color 0.3s, box-shadow 0.3s", // Add transition for box-shadow
                            boxShadow: openIndex === index
                                ? "0 4px 12px rgba(0, 0, 0, 0.2)" // Stronger shadow when open
                                : "0 4px 8px rgba(0, 0, 0, 0.1)" // Lighter shadow when closed
                        }}
                        onClick={() => toggleAccordion(index)}
                    >
                        <span style={{ fontFamily: "Regular" }}>{faq.question}</span>
                        <span
                            style={{
                                transform: openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "transform 0.3s ease"
                            }}
                        >
                            &#9660; {/* Down chevron */}
                        </span>
                    </div>
                    {openIndex === index && (
                        <div style={{ padding: getIsMobile() ? "10px" : "1px", backgroundColor: "#fff", borderRadius: "0 0 8px 8px" }}>
                            {formatAnswer(faq.answer)}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

// Main Component
interface GotAQuestionProps { }

const header1 = "Any Questions?";
//outperform
//A new season begins on the 1st and the 16th of every month at Midnight EST (5am GMT).\n
export const GotAQuestion: React.FC<GotAQuestionProps> = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const isMobile = getIsMobile()
    const isTablet = getIsTablet()
    const isMobileOrTablet = isMobile || isTablet



    return (
        <div
            className="home-container"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                position: "relative",
                flexDirection: "column"
            }}
        >
            <div
                style={{
                    height: "auto",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                }}
            >
                <div style={{ position: "absolute", width: "100%", display: "flex", height: "100%", backgroundColor: "rgba(186, 234, 201)" }}>

                    {backgroundDiv(isMobile, isTablet, isMobileOrTablet)}
                </div>
                <div
                    style={{
                        marginTop: "10%", justifyContent: "center", position: "relative",

                        width: "100%",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column", zIndex: 1,
                    }}
                >
                    <WhiteOutlineText
                        textStyle={{
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(
                                getScreenSize().height * 0.1,
                                getScreenSize().width * 0.9,
                                header1.length,
                                88
                            ),
                            width: "90%",
                            justifyContent: "center",
                            textAlign: "center"
                        }}
                        viewStyle={{

                            width: "90%",
                            justifyContent: "center",
                            textAlign: "center"
                        }}
                    >
                        {header1}
                    </WhiteOutlineText>
                </div>

                {/* FAQ Accordion */}
                <div style={{
                    minHeight: Math.max(getScreenSize().height * 0.40, getScreenSize().width * 0.50),
                    marginTop: "7.5%", marginBottom: "7.5%", justifyContent: "center", alignItems: "center", width: "100%", display: "flex", zIndex: 1,
                }}>
                    <FAQAccordion openIndex={openIndex} setOpenIndex={setOpenIndex} faqs={faqs} />
                </div>

            </div>

        </div>
    );
};


export const GotAQuestionDesktop: React.FC<GotAQuestionProps> = () => {
    const isMobile = getIsMobile()
    const isTablet = getIsTablet()
    const isMobileOrTablet = isMobile || isTablet
    const [openIndex, setOpenIndex] = useState<number | null>(null);


    return (
        <div
            className="home-container"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                position: "relative",
                flexDirection: "column"
            }}
        >
            <div
                style={{
                    height: "auto",

                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                }}
            >
                <div style={{ position: "absolute", width: "100%", display: "flex", height: "100%", backgroundColor: "#bdead6", overflow: "hidden" }}>

                    {getIsTablet() ? null : <img
                        src={BluePlayWithFriends}
                        alt="Daily Tournament Tile"
                        style={{
                            width: "40%",
                            height: "auto",

                            objectFit: "cover",
                            position: "absolute",
                            top: 0,
                            left: "0"
                        }}
                    />}
                    <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",

                        //   background: 'linear-gradient(90deg,rgba(200, 240, 220, 0) 30%, rgba(180, 230, 205, 1) 40%,  rgb(190, 235, 215) 80%,  rgb(170, 225, 200) 100%)'
                    }}></div>
                    {openIndex != null && <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",

                        background: 'linear-gradient(180deg,rgba(200, 240, 220, 0) 70%, rgba(200, 240, 220, 1) 80%,  rgb(170, 225, 200) 100%)'
                    }}></div>}
                </div>
                <div
                    style={{
                        justifyContent: "center",
                        width: "45%",
                        height: getScreenSize().height * 0.6,
                        alignItems: "center",
                        display: "flex",
                        position: "relative",
                        flexDirection: "column", zIndex: 1,

                    }}
                >
                    <h1
                        style={{
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(
                                getScreenSize().height * 0.15,
                                getScreenSize().width * 0.3,
                                header1.length,
                                88
                            ),
                            width: "90%",
                            justifyContent: "center",
                            textAlign: "center",
                            alignItems: "center",
                            textShadow: `
                    -1px -1px 4px white,
                     1px -1px 4px white,
                    -1px  1px 4px white,
                     1px  1px 4px white
                `
                        }}

                    >
                        {header1}
                    </h1>
                </div>

                {/* FAQ Accordion */}
                <div style={{
                    position: "relative",
                    justifyContent: "center", alignItems: "center", width: "55%", height: "auto", display: "flex", zIndex: 1,
                }}>
                    <div style={{
                        position: "absolute", display: "flex",
                        flex: 1, height: "100%",
                        top: 0,
                        left: "-10%",
                        width: "110%", opacity: 0.1,
                        backgroundImage: `url(${AppLogoTeal})`,
                        backgroundRepeat: "repeat-x",
                        backgroundSize: "50% auto", // or 'contain' or 'cover' depending on desired effect
                        backgroundPosition: "left center"
                    }}>
                        {/* <img
                            src={AppLogoTeal} // Reference the imported image
                            alt="Daily Tournament Tile" // Provide an alt attribute
                            style={{
                                height: '80%',
                                objectFit: 'contain',
                                position: "relative",
                                paddingRight: "3%"

                            }}
                        /> */}
                    </div>
                    <div style={{

                        marginTop: "7.5%", marginBottom: "7.5%", justifyContent: "center", alignItems: "center", width: "100%", display: "flex", zIndex: 1,

                    }}>
                        <FAQAccordion openIndex={openIndex} setOpenIndex={setOpenIndex} faqs={faqs} />
                    </div>
                </div>

            </div>

        </div>
    );
};